import { ISearchParameters, ITableReport } from "./TableInterfaces";

export interface IAdjustmentConfig {
  buyCall: IAdjustmentOption;
  sellCall: IAdjustmentOption;

  buyPut: IAdjustmentOption;
  sellPut: IAdjustmentOption;

  buyBase: IAdjustmentBuyBase;
  sellBase: IAdjustmentSellBase;
}
export interface IAdjustment2Config {
  buyCall: IAdjustment2Option;
  sellCall: IAdjustment2Option;

  buyPut: IAdjustment2Option;
  sellPut: IAdjustment2Option;

  buyBase: IAdjustmentBuyBase;
  sellBase: IAdjustmentSellBase;
}

export interface IAdjustment2Reference {
  call: IAdjustment2ReferenceOption;
  put: IAdjustment2ReferenceOption;
  groupId: string;
  callInsId1: string;
  callInsId2: string;
  putInsId1: string;
  putInsId2: string;
}

export interface IAdjustment2ManualGroupReference {
  groupId: string;
  callInsId1: string;
  callInsId2: string;
  putInsId1: string;
  putInsId2: string;
}
export interface IAdjustment2ReferenceOption {
  minLastTrade: number;
  minRemainingDay: number;
  maxRemainingDay: number;
  minAbsDelta: number;
  checkDueDate: boolean;
  checkBaseInstrument: boolean;
}

export interface ICustomAdjustmentConfig {
  incremental: string[];
  decremental: string[];
}

export interface IAdjustmentOption {
  maxGama: number;
  dailyLock_Reinforcement: number;
  dailyLock_Netural: number;
  dailyLock_Weaken: number;
  normalBubble_Border: number;
  min_delta: number;
  min_trade: number;
  minRemainingDays: number;
  maxRemainingDays: number;
}
export interface IAdjustment2Option {
  minDailyLockProfitReinforcement: number;
  minDailyLockProfitSameKind: number;
  minDailyLockProfitDifferentKind: number;
  minDailyLockProfitDifferentApplyDay: number;
  minDailyLockProfitDifferentWeak: number;
  relativeNormalBubbleTreshold: number;
  minAbsDiffrential: number;
  minAbsDelta: number;
  minLastTrade: number;
  minRemainingDay: number;
  maxRemainingDay: number;
}

export interface IAdjustmentBuyBase {
  maxBubbleNormal: number;
}

export interface IAdjustmentSellBase {
  minBubbleNormal: number;
}

export interface IAdjustmentTablesSearchParam extends ISearchParameters {
  groupId: number;
}

export enum DeltaGammaIncDec {
  Incremental = 1,
  Decremental,
}
export interface IAdjustment2SearchParam extends ISearchParameters {
  delta: DeltaGammaIncDec;
  gamma: DeltaGammaIncDec;
  groupId: number;
}

export interface IDecrementalOptionTableReport extends ITableReport {}
export interface IDecrementalBaseTableReport extends ITableReport {}
export interface IIncrementalOptionTableReport extends ITableReport {}
export interface IIncrementalBaseTableReport extends ITableReport {}

export interface IDeltaGammaTableReport extends ITableReport {}

export enum RefrenceType {
  CS = 1,
  PS = 2,
}
export interface IDailyReferenceGraphDTO {
  groupId: number;
  fromDate?: string | null;
  toDate?: string | null;
  refrenceType: RefrenceType;
}

export interface IHourlyPortfoValueGraphDTO {
  groupId: number;
  date?: string | null;
  fromTime?: string | null;
  toTime?: string | null;
}
export interface IOptionDomainChartsReport extends ITableReport {}
